import Icon from '../../../components/AppIcon';
import { UpcomingDay } from '../types';

interface UpcomingScheduleProps {
  upcomingDays: UpcomingDay[];
}

const UpcomingSchedule = ({ upcomingDays }: UpcomingScheduleProps) => {
  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
    }).format(date);
  };

  return (
    <div className="bg-card border border-border rounded-md shadow-elevation-1 p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Upcoming Contribution Days</h2>
        <Icon name="Calendar" size={20} className="text-muted-foreground" />
      </div>
      <div className="space-y-4">
        {upcomingDays.map((day) => (
          <div
            key={day.id}
            className="p-4 rounded-md border border-border hover:border-primary transition-interactive"
          >
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="text-sm font-medium text-foreground mb-1">
                  {day.dayName}
                </h3>
                <p className="text-xs text-muted-foreground">{formatDate(day.date)}</p>
              </div>
              {day.reminderSent ? (
                <div className="flex items-center gap-1 px-2 py-1 rounded-sm bg-success/10 text-success text-xs font-medium">
                  <Icon name="CheckCircle" size={14} />
                  <span>Reminder Sent</span>
                </div>
              ) : (
                <div className="flex items-center gap-1 px-2 py-1 rounded-sm bg-muted text-muted-foreground text-xs font-medium">
                  <Icon name="Clock" size={14} />
                  <span>Pending</span>
                </div>
              )}
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">Participation Rate</span>
                <span className="font-medium text-foreground">
                  {day.participationRate}%
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                <div
                  className="h-full bg-primary rounded-full transition-all"
                  style={{ width: `${day.participationRate}%` }}
                />
              </div>
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>
                  {day.contributedMembers} of {day.totalMembers} members
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingSchedule;